import * as Yup from "yup";

export const staffStatisticsSchema = Yup.object().shape({
  institution_id: Yup.string().required("Institution is required"),
  focus_area_stats: Yup.array().of(
    Yup.object().shape({
      focus_area_id: Yup.string().required("Focus Area is required"),

      phd_staff_count_full_time: Yup.number()
        .transform((value, originalValue) =>
          String(originalValue).trim() === "" ? undefined : value
        )
        .typeError("Full Time must be a number")
        .required("Full Time is required")
        .min(0, "Full Time cannot be negative"),

      phd_staff_count_part_time: Yup.number()
        .transform((value, originalValue) =>
          String(originalValue).trim() === "" ? undefined : value
        )
        .typeError("Part Time must be a number")
        .required("Part Time is required")
        .min(0, "Part Time cannot be negative"),

      phd_staff_count_retained: Yup.number()
        .transform((value, originalValue) =>
          String(originalValue).trim() === "" ? undefined : value
        )
        .typeError("Retained must be a number")
        .required("Retained is required")
        .min(0, "Retained cannot be negative"),
    })
  ),
});
